/**
 * @generated SignedSource<<eb0b491bf2ee2d21ffeae8078f428e45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamSettingsMutation$variables = {
  setting: string;
  streamId: string;
  value?: string | null;
};
export type StreamSettingsMutation$data = {
  readonly noteStreamSetting: {
    readonly stream: {
      readonly carryActionItems: boolean | null;
      readonly carryActionItemsAsLinks: boolean;
      readonly carryForwardWithNestedBlocks: boolean;
      readonly carryTalkingPoints: boolean | null;
      readonly objectivesFilterAssignee: any | null;
      readonly objectivesFilterCycle: any | null;
      readonly objectivesFilterStatus: string | null;
      readonly objectivesTabEnabled: boolean | null;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type StreamSettingsMutation = {
  response: StreamSettingsMutation$data;
  variables: StreamSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setting"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "setting",
    "variableName": "setting"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryTalkingPoints",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryActionItems",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryActionItemsAsLinks",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryForwardWithNestedBlocks",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesTabEnabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterAssignee",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterStatus",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterCycle",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamTabNode",
  "kind": "LinkedField",
  "name": "tabs",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherStreamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmbedded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteStreamSettingsMutation",
        "kind": "LinkedField",
        "name": "noteStreamSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "StreamSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteStreamSettingsMutation",
        "kind": "LinkedField",
        "name": "noteStreamSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v13/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47b7f98e112c5fabd138e5813c003db1",
    "id": null,
    "metadata": {},
    "name": "StreamSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation StreamSettingsMutation(\n  $streamId: ID!\n  $setting: String!\n  $value: String\n) {\n  noteStreamSetting(streamId: $streamId, setting: $setting, value: $value) {\n    stream {\n      carryTalkingPoints\n      carryActionItems\n      carryActionItemsAsLinks\n      carryForwardWithNestedBlocks\n      objectivesTabEnabled\n      objectivesFilterAssignee\n      objectivesFilterStatus\n      objectivesFilterCycle\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "966096f76aa7c00579677bfaeb0caecb";

export default node;
